import Jwt from "@/common/jwt";
// api
import { WEB_URL } from "@/common/config";

const interceptor = (axiosInstance) => (error) => {
  const _axios = axiosInstance;
  const originalRequest = error.config;

  console.log(_axios);
  if (error.response) {
    // 리프레시 토큰을 받지 않고 로그아웃
    if (error.response.status === 401) {
      console.log(originalRequest);
      Jwt.destroyRefreshToken;
      Jwt.destroyAccessToken();
      window.location.replace(WEB_URL);
      window.location.reload();
    }
  }

  return Promise.reject(error);
};

export default interceptor;
